
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class GSTR2Grid extends Serenity.EntityGrid<PurchaseTaxRow, any> {
        protected getColumnsKey() { return 'Purchase.GSTR2'; }
        protected getIdProperty() { return PurchaseTaxRow.idProperty; }
        protected getInsertPermission() { return PurchaseTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseTaxRow.localTextPrefix; }
        protected getService() { return GSTR2Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();


            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('NetAmount'),
                    new Slick.Aggregators.Sum('IntegratedTaxAmount'),
                    new Slick.Aggregators.Sum('CentralTaxAmount'),
                    new Slick.Aggregators.Sum('StateTaxAmount'),
                    new Slick.Aggregators.Sum('CessAmount'),
                    new Slick.Aggregators.Sum('GrossAmount')]
            });
            return grid;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        //protected getQuickFilters() {
        //    var filters = super.getQuickFilters();

        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: OMS.FinancialYearRow.lookupKey,
        //            multiple: true

        //        },
        //        field: 'FinancialYearId',
        //        title: 'Year',
        //        handler: w => {
        //            var temp= [];
        //            var values = w.value;
        //            for (var i = 0; i < values.length; i++) {
        //                temp.push(parseInt(values[i]));
        //            } if (temp.length != 0) {
        //                (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
        //                //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
        //                //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
        //            }
        //        },
                
        //        cssClass: 'hidden-xs'
        //    });
        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: OMS.CompanyRow.lookupKey,
        //            multiple: true

        //        },
        //        field: 'LedgerId',
        //        title: 'Company',
        //        handler: w => {
        //            var temp = [];
        //            var values = w.value;
        //            for (var i = 0; i < values.length; i++) {
        //                temp.push(parseInt(values[i]));
        //            } if (temp.length != 0) {
        //                (this.view.params as ReportFiltersRequest).CompanyIds = temp;
        //            }
        //        },

        //        cssClass: 'hidden-xs'
        //    });

        //    return filters;
        //}
        //protected createSlickGrid(): Slick.Grid {
        //    let grid = super.createSlickGrid();
        //    //grid.registerPlugin(this.autoSize);
        //    grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
        //    this.view.setGrouping([{

        //        getter: 'VoucherNo',
        //        displayTotalsRow: false,
        //    }])
        //    return grid;
        //}
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push(Common.PdfExportHelper.createToolButton({
            //    grid: this,
            //    onViewSubmit: () => this.onViewSubmit()
            //}));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print Register',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
            //        Common.ReportHelper.execute({
            //            reportKey: 'Finance.ContraRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}